import { FunctionComponent, useEffect, useState } from "react";

import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";
import { useAuth } from "@voxmedia/duet-context/context/auth-context";
import { useConfigContext } from "@voxmedia/duet-context/context/config-context";

import * as styles from "./NavigationDrawerIdentityAuth.css";

const NavigationDrawerIdentityAuth: FunctionComponent = () => {
  const { user } = useAuth();
  const analytics = useAnalytics();
  const [authLink, setAuthLink] = useState("/auth/login?returnPath=/");
  const { communityConfig, membershipConfig } = useConfigContext();

  useEffect(() => {
    const { ssoAuthDomain, isPrimaryCommunity } = communityConfig;
    const { protocol, href, pathname } = window.location;

    let authLink: string;

    // If this community is part of an SSO network but not the primary community,
    // redirect to the SSO auth host for login with a returnTo param back to the current URL.
    if (ssoAuthDomain && !isPrimaryCommunity) {
      authLink = `${protocol}//${ssoAuthDomain}/auth/sso?returnTo=${encodeURIComponent(href)}`;
    } else {
      // Either this community is the primary community or it is not part of an SSO network
      // so proceed with the normal login/signup flow.
      authLink = `/auth/login?returnPath=${encodeURIComponent(pathname)}`;
    }

    setAuthLink(authLink);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSignout = async () => {
    analytics?.emit({
      event: "authentication",
      authentication: { method: "logout" },
    });

    await fetch("/api/auth/firebase-logout");

    // Reload the page
    location.reload();
  };

  if (user) {
    return (
      <ul className={styles.list}>
        <li className={styles.listItem}>
          <a className={styles.link} href={"/account/profile"}>
            Your Account
          </a>
          <div className={styles.separator}> / </div>
          <button className={styles.link} onClick={() => void onSignout()}>
            Log Out
          </button>
        </li>
      </ul>
    );
  }

  return (
    <ul className={styles.list}>
      <li className={styles.listItem}>
        <a
          className={styles.link}
          href={authLink}
          onClick={() => {
            analytics?.emit({
              event: "authentication",
              authentication: { method: "log in" },
            });
          }}
        >
          Login
        </a>
        {!membershipConfig.hideSignUp && (
          <>
            <div className={styles.separator}> / </div>
            <a
              className={styles.link}
              href={authLink}
              onClick={() => {
                analytics?.emit({
                  event: "authentication",
                  authentication: { method: "sign up" },
                });
              }}
            >
              Sign Up
            </a>
          </>
        )}
      </li>
    </ul>
  );
};

export default NavigationDrawerIdentityAuth;
